<template>
  <div class="account">
    <Form ref='forms'></Form>
    <div class="top wbg">
      <a-row :gutter="24" type="flex">
        <a-col :span="6" class="col">
          <label>所属机构：</label>
          <!-- <a-input v-model="form.title" placeholder="请输入机构名称" style="width:100%;"></a-input> -->
          <a-select style="width:100%;" show-search v-model="form.user_group_id" placeholder="请选择机构" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="item in user_group" :key="item.id" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="col">
          <label>账号名称：</label>
          <a-input v-model="form.uname" placeholder="请输入账号名称" style="width:100%;"></a-input>
        </a-col>
        <a-col :span="6" class="col">
          <label>关联原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" style="width:100%;" :maxTagCount='1'
            :maxTagTextLength='5' mode="multiple" allowClear>
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="col">
          <a-button icon="search" @click="form.page = 1; query()" style="margin-right:20px;height: 32px;">查询</a-button>
          <a-button @click="reset" style="margin-right:20px;height: 32px;">重置</a-button>
          <a-button icon="plus" style="height: 32px;" @click="linkTo()">新增用户</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="tcon wbg">
      <div class="tableList">
        <table class="table" style="table-layout: fixed;">
          <thead class="thead">
            <td width='60'>序号</td>
            <td width='80'>所属机构</td>
            <td width='80'>账号名称</td>
            <td width='380'>关联原告</td>
            <td width='60'>账号状态</td>
            <td width='60'>内部用户</td>
            <!-- <td width='80'>用户组</td> -->
            <td width='100'>操作</td>
          </thead>
          <tbody>
            <tr v-for='(i, index) in list' :key='i.id'>
              <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
              <!-- <td> {{ i.title }}</td> -->
              <td>
                <p v-for='j in i.user' :key='j.id'>
                  {{ j.user_group ? j.user_group.title : '/' }}
                </p>
              </td>
              <td>
                <p v-for='j in i.user' :key='j.id'>
                  {{ j.uname || '/' }}
                </p>
              </td>
              <td>
                <div class="p" v-for='j in i.user' :key='j.id'>
                  <span v-if='j.accuser.length == 0'>/</span>
                  <div style='max-width:90%;' v-else>
                    <Tooltip :tit='j.accuser | rTit'></Tooltip>
                  </div>
                </div>
              </td>

              <td>
                <p v-for='j in i.user' :key='j.id'>
                  <font color='#3eab09' v-if='j.audit == 1'>启用</font>
                  <font color='#f00' v-else>禁用</font>
                </p>
              </td>
              <td>
                <p v-for='j in i.user' :key='j.id'>
                  <font color='#3eab09' v-if='j.is_inner_user == 1'>是</font>
                  <font color='#f00' v-else>否</font>
                </p>
              </td>
              <!-- <td>
                <p v-for='j in i.user' :key='j.id'>
                  {{ j.user_group ? j.user_group.title : '/' }}
                </p>
              </td> -->
              <td>
                <p v-for='j in i.user' :key='j.id'>
                  <router-link :to="{ path: '/account/edit', query: { id: j.id } }">修改</router-link>
                  <a-popover title="修改提醒时间" trigger="click">
                    <template slot="content">
                      <a-date-picker v-model="auditTime" placeholder="请选择" show-time style="width: 100%;" type="date"
                        valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' />
                      <a-button type="primary" style="margin-top: 10px;" @click='del(j)'>提交</a-button>
                    </template>
                    <a href='javascript:void(0);' v-if='$store.state.user.id == 1' class="del"
                      @click="auditTime = null">修改提醒时间</a>
                  </a-popover>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pages" v-if="count > 10">
          <a-pagination v-model="form.page" show-quick-jumper :total="count" show-less-items :pageSize='10'
            @change='turnpage' />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccount, changeAuditTime, userGrounp } from '@/server/user'
import { getAccuserAll } from '@/server/api'
import Form from './form.vue'
export default {
  data() {
    return {
      accuserList: [],
      list: [],
      count: 0,
      auditTime: '',
      form: {
        accuser_id: [],
        title: '',
        page: 1,
        limit: 10
      },
      modalVisible: false,
      user_group: [],
    }
  },
  components: { Form },
  filters: {
    rTit(val) {
      if (val) {
        let letter = ''
        val.map(ele => {
          letter += (ele.accuser ? ele.accuser.title : '/') + ','
        })
        return letter.slice(0, -1)
      } else {
        return ''
      }
    }
  },
  created() {
    this.query()
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    userGrounp('index').then((res) => {
      this.user_group = res.list;
    })
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      // console.log(e)
      if (e.keyCode == 13) {
        _this.query()
      }
    }
  },
  methods: {
    linkTo() {
      this.$refs.forms.visible = true;
    },
    turnpage(val) {
      this.form.page = val;
      this.query()
    },
    del(item) {
      if (!this.auditTime) return false;
      changeAuditTime({ time: this.auditTime, user_id: item.id }).then(e => {
        this.$message.success('已修改提醒时间')
        setTimeout(() => { window.history.go(0) }, 200)
      })
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      getAccount(form).then((res) => {
        this.list = res.list;
        this.count = res.count
      })
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.title = ''
      this.form.uname = ''
      this.form.accuser_id = []
      this.query()
    }
  }
}
</script>
<style lang="less" scoped>
.col {
  display: flex;
  align-items: center;

  label {
    white-space: nowrap;
  }
}

.account {
  .top {
    padding: 20px;

    .group {
      display: flex;
      align-items: center;
    }

    .to {
      display: inline-block;
      width: 20px;
      height: 1px;
      margin: 0 10px;
      background-color: #dbdcde;
      vertical-align: middle;
    }

    form {
      width: 100%;
    }

    .label {
      display: inline-block;
      margin-right: 60px;
      font-size: 0.875rem;
      color: #0e2949;
    }

    .btns {
      float: right;

      button {
        margin-left: 20px;
        min-width: 90px;
      }
    }
  }
}

// .ant-btn {
//   border-color: #1d8bfe;
//   color: #1d8bfe;
// }

// .ant-btn-primary {
//   color: #ffffff;
//   border-color: #1d8bfe;
//   background-color: #1d8bfe;
// }

.tcon {
  padding: 0 20px;
  min-height: 760px;

  .tableList {
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          .del {
            margin-left: 20px;
          }

          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p,
          .p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}

.modal-footer {
  text-align: center;

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}

.pages {
  text-align: right;
}
</style>
